import PropTypes from "prop-types"
import classNames from "classnames"
import { identity } from "lodash"
import { Grid } from "@mui/material"
import { StarRounded } from "@mui/icons-material"
import { VALUE } from "./shape"
import Ellipsable from "components/ellipsable"

export default function Row({ id, label, original, rebalanced, delta, favorite, color = "", formatter = identity, fixed, maxLabelWidth }) {
  return <Grid container key={id} className={classNames("panel-row", { favorite, fixed })}>
    <Grid container item className="metric">
      <span className="label">
        {favorite && <StarRounded className="star-icon" style={{ color }} />}
        <Ellipsable width={maxLabelWidth}>{label}</Ellipsable>
      </span>
    </Grid>
    <Grid container item className="values">
      <div className="optimizer">{formatter(rebalanced)}</div>
      <div className="original">{formatter(original)}</div>
      <div className="delta">{formatter(delta)}</div>
    </Grid>
  </Grid>
}

Row.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  original: VALUE,
  rebalanced: VALUE,
  delta: VALUE,
  color: PropTypes.string,
  favorite: PropTypes.bool,
  formatter: PropTypes.func,
  fixed: PropTypes.bool,
  maxLabelWidth: PropTypes.number,
}
